<section>
    <h2>Dashboard</h2>
    <app-vcl-filter [pageId]="pageId" [filterType]="'study'" [userInfos]="userInfos" [modes]="modes" [platformInfos]="platformInfos" (filterDataOutputEvent)="loadDashboardData($event)">
    </app-vcl-filter>
    <app-dashboard [userInfos]="userInfos" [data]="data" [platformInfos]="platformInfos"></app-dashboard>
</section>